import moment from 'moment';

function sanitizeValue(value: any) {
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No';
  }
  return value;
}

function formatDiff(__new: any, __old: any) {
  let old = '';
  let neww = '';

  const processEntries = (entries: [string, any][], target: 'old' | 'new') => {
    for (const [fieldName, diffObj] of entries) {
      if (!['created_at', 'updated_at', 'id', 'user'].includes(fieldName)) {
        if (target === 'old') {
          old += `${diffObj} \n`;
        } else {
          neww += `${diffObj} \n`;
        }
      }
    }
  };

  if (typeof __new === 'object' && __new !== null && __old == null) {
    processEntries(Object.entries(__new), 'new');
  }

  if (typeof __old === 'object' && __old !== null && __new == null) {
    processEntries(Object.entries(__old), 'old');
  }

  if (typeof __old === 'object' && __old !== null && typeof __new === 'object' && __new !== null) {
    processEntries(Object.entries(__old), 'old');
    processEntries(Object.entries(__new), 'new');
  }

  return [neww, old];
}

// Define a type for the diff object
type DiffObject = {
  __new?: any;
  __old?: any;
  [key: string]: any;
};

export function diffShow(parcel_logs: any) {
  const timelineSection = parcel_logs.map((log: any) => {
    const { type, details, diff, created_at, user } = log;
    const timeline = `${moment(created_at).format('DD-MMM-YYYY')} \n ${moment(created_at).format('hh:mm a')} ${
      user?.username ? '\n ' + JSON.stringify(user?.username) : ''
    }`.replace(/"/g, '');

    const logs = [];
    if (diff) {
      for (const [fieldName, diffObj] of Object.entries(diff as Record<string, DiffObject>)) {
        try {
          if (diffObj.__new ?? diffObj.__old) {
            if (
              (typeof diffObj.__new === 'object' && diffObj.__new !== null) ||
              (typeof diffObj.__old === 'object' && diffObj.__old !== null)
            ) {
              const [neww, old] = formatDiff(diffObj.__new, diffObj.__old);
              logs.push([fieldName, neww, old]);
            } else {
              logs.push([fieldName, sanitizeValue(diffObj.__new), sanitizeValue(diffObj.__old)]);
            }
          } else {
            for (const [key, value] of Object.entries(diffObj)) {
              if (!['created_at', 'updated_at', 'id', 'user'].includes(key)) {
                logs.push([key, sanitizeValue(value.__new), sanitizeValue(value.__old)]);
              }
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    }

    return { timeline, logs, type, details };
  });

  return timelineSection;
}
